import { useState } from 'react';
import { contestants, categories } from '@/mocks/chigua';

const banners = [
  {
    icon: 'ri-mic-fill',
    title: '实力唱将争霸',
    desc: '高音、共鸣、现场感染力多维比拼，谁才是这个夏天最能唱的人？',
    img: 'https://readdy.ai/api/search-image?query=Warm%20stage%20spotlight%20on%20a%20singing%20contest%20with%20golden%20and%20red%20bokeh%20lights%2C%20microphone%20in%20front%2C%20deep%20raspberry%20and%20coral%20color%20palette%2C%20cinematic%20concert%20backdrop%2C%20dramatic%20atmosphere%2C%20high%20quality&width=800&height=500&seq=chigua-singer-2026-x1&orientation=landscape',
  },
  {
    icon: 'ri-disc-fill',
    title: '舞台炸场名场面',
    desc: '每一个高光瞬间都在出圈，盘点本季最炸裂的舞台现场与话题时刻。',
    img: 'https://readdy.ai/api/search-image?query=Exciting%20pop%20concert%20dance%20performance%20silhouette%20under%20colorful%20warm%20spotlights%20and%20confetti%2C%20energy%20and%20motion%2C%20red%20orange%20golden%20palette%2C%20cinematic%20stage%20lighting%2C%20high%20quality&width=800&height=500&seq=chigua-stage-2026-x1&orientation=landscape',
  },
  {
    icon: 'ri-emotion-laugh-fill',
    title: '快乐源泉 · 喜剧瞬间',
    desc: '搞笑担当们的名场面合集，承包你整个夏天的笑点与快乐。',
    img: 'https://readdy.ai/api/search-image?query=Joyful%20variety%20show%20studio%20with%20smiling%20audience%20and%20bright%20playful%20colorful%20decor%20balloons%2C%20warm%20orange%20yellow%20and%20coral%20palette%2C%20lively%20happy%20atmosphere%2C%20cinematic%20broadcast%20style%2C%20high%20quality&width=800&height=500&seq=chigua-comedy-2026-x1&orientation=landscape',
  },
];

export default function Shows() {
  const [cat, setCat] = useState('全部');
  const list = cat === '全部' ? contestants : contestants.filter((c) => c.category === cat);

  return (
    <section id="shows" className="w-full bg-leaf-50/60 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-melon-500 uppercase">
            <i className="ri-star-smile-line"></i> Highlights
          </span>
          <h2 className="mt-3 font-display font-bold text-3xl md:text-5xl text-ink">本季参赛看点 · 名场面不断</h2>
          <p className="mt-3 text-sm md:text-base text-ink/60">
            台前的高光与台下的努力，都在这里被看见。挑一个你感兴趣的方向，为你喜欢的选手打call。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {banners.map((b, idx) => (
            <article key={idx} className="group rounded-2xl overflow-hidden bg-white border border-leaf-100 hover:shadow-sm transition-all">
              <div className="relative h-48 overflow-hidden">
                <img src={b.img} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 w-9 h-9 rounded-full bg-white/95 flex items-center justify-center text-melon-500 text-lg">
                  <i className={b.icon}></i>
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-display font-bold text-lg text-ink">{b.title}</h3>
                <p className="mt-1.5 text-sm text-ink/60 leading-relaxed">{b.desc}</p>
                <a href="#ranking" className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-leaf-600 hover:text-leaf-700 whitespace-nowrap cursor-pointer">
                  去围观打榜 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 flex flex-wrap gap-2 justify-center">
          {categories.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                cat === c ? 'bg-ink text-white' : 'bg-white text-ink/70 border border-ink/10 hover:bg-ink/5'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {list.map((c) => (
            <article key={c.id} className="group rounded-2xl bg-white border border-ink/5 p-5 hover:-translate-y-1 transition-transform">
              <img src={c.avatar} alt={`选手${c.name}展示`} className="w-full aspect-square object-cover rounded-xl" />
              <div className="mt-3 flex items-center justify-between">
                <h3 className="font-display font-bold text-ink">{c.name}</h3>
                <span className="text-xs text-melon-600 bg-melon-50 rounded-full px-2 py-0.5 whitespace-nowrap">{c.category}</span>
              </div>
              <p className="mt-1 text-sm text-ink/60">{c.tagline}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}